import { AppData, BookingData } from "../../types";

import { CompleteBookingQuestionsStepPayload } from "../../actions";
import { Mixpanel } from "../../../mixpanel";

export type CompleteBookingQuestionsStepOptions = {
  appData: AppData;
  payload: CompleteBookingQuestionsStepPayload;
};

export const completeBookingQuestionsStep = (
  options: CompleteBookingQuestionsStepOptions,
): AppData => {
  Mixpanel.track({
    name: "Completed step",
    props: { step: "bookingQuestions" },
  });
  const updatedBookingData: BookingData = {
    ...options.appData.bookingData,
    ...options.payload.updatedData,
  };
  return {
    ...options.appData,
    bookingData: updatedBookingData,
    currentStep: "details",
  };
};
